import React, { Suspense, useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

//general
import PrivateRoute from './components/PrivateRoute';
import loadingAnimation from './lotties/loading.json';
import Lottie from 'react-lottie';
import { useSelector } from 'react-redux';

const ElementDetails = React.lazy(() => import('./screens/mainPages/ElementDetails'));
const ModuleList = React.lazy(() => import('./screens/mainPages/ModuleList'));
const Workspaces = React.lazy(() => import('./screens/mainPages/Workspaces'));
const Inbox = React.lazy(() => import('./screens/mainPages/Inbox'));
const UserParams = React.lazy(() => import('./screens/mainPages/UserParams'));
const NodeAI = React.lazy(() => import('./sidebars/NodeAI'));
const DashboardNode = React.lazy(() => import('./screens/specific/DashboardNode'));
const ExtensionsList = React.lazy(() => import('./screens/mainPages/ExtensionsList'));
const ElementDetailsWS = React.lazy(() => import('./screens/workshopPages/ElementDetails'));
const ModuleListWS = React.lazy(() => import('./screens/workshopPages/ModuleList'));
const ExtensionsListWS = React.lazy(() => import('./screens/workshopPages/ExtensionsList'));
const WorkspacesWS = React.lazy(() => import('./screens/workshopPages/Workspaces'));


const BosRoutes = () => {

  const currentPlatform = useSelector(state => state.core.currentPlatform);
  const [isAnimationPlaying, setIsAnimationPlaying] = useState(true);

  useEffect(() => {
    return () => {
      setIsAnimationPlaying(false);
    };
  }, []);

  return (
    <Suspense fallback={
      <div>
        <div className="loader">
          Loading...
        </div>
      </div>
    }>
      <Routes>
        <Route
          path="/dashboard-node"
          element={
            <PrivateRoute
              permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER', 'PERSONAL']}
            >
              <DashboardNode />
            </PrivateRoute>
          }
        />
        <Route
          path="/me"
          element={
            <PrivateRoute
              permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER', 'PERSONAL']}
            >
              <UserParams />
            </PrivateRoute>
          }
        />
        <Route
          path="/node-ai"
          element={
            <PrivateRoute
              permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER', 'PERSONAL']}
            >
              <NodeAI />
            </PrivateRoute>
          }
        />

        [///////////////////////// General //////////////////////////]
        <Route
          path="/:collection/:moduleName/:moduleId/:structureId"
          element={
            <PrivateRoute permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER']}>
              {currentPlatform === 'CHEKUP' ? <ModuleListWS /> : <ModuleList />}
            </PrivateRoute>
          }
        />
        <Route
          path="/:collection/:moduleName/:moduleId/:structureId/:segmentId"
          element={
            <PrivateRoute permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER']}>
              {currentPlatform === 'CHEKUP' ? <ModuleListWS /> : <ModuleList />}
            </PrivateRoute>
          }
        />
        <Route
          path="/element/:moduleName/:structureId/:elementId"
          element={
            <PrivateRoute permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER']}>
              {currentPlatform === 'CHEKUP' ? <ElementDetailsWS /> : <ElementDetails />}
            </PrivateRoute>
          }
        />
        <Route
          path="/nodes/:nodeId"
          element={
            <PrivateRoute permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER']}>
              {currentPlatform === 'CHEKUP' ? <WorkspacesWS /> : <Workspaces />}
            </PrivateRoute>
          }
        />


        <Route
          path="/inbox"
          element={
            <PrivateRoute permission={['ADMIN', 'OWNER']}>
              <Inbox />
            </PrivateRoute>
          }
        />



        <Route
          path="/extensions/:extensionId"
          element={
            <PrivateRoute permission={['ADMIN', 'OWNER']}>
              {currentPlatform === 'CHEKUP' ? <ExtensionsListWS /> : <ExtensionsList />}
            </PrivateRoute>
          }
        />

        <Route
          path="/extensions/:extensionId/:codeId"
          element={
            <PrivateRoute permission={['ADMIN', 'OWNER']}>
              {currentPlatform === 'CHEKUP' ? <ExtensionsListWS /> : <ExtensionsList />}
            </PrivateRoute>
          }
        />

      </Routes>
    </Suspense>
  );
};

export default BosRoutes;
